import { Component, AfterViewInit, Input } from '@angular/core';
import { CaseService } from '../../shared/services/case.service';
import { UserService } from '../../shared/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-allocate',
  templateUrl: './allocate.component.html',
  styleUrls: ['./allocate.component.scss']
})
export class AllocateComponent implements AfterViewInit {

  @Input() caseId: number;

  paralegalUsers: any[] = [];
  adminUsers: any[] = [];

  selectedParalegal: any = null;
  selectedAdmin: any = null;

  invalidSelection: boolean = true;
  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private caseService: CaseService,
    userService: UserService
  ) {
    userService.paralegals().subscribe(results => {
      this.paralegalUsers = results.map(user => ({ name: user.firstName + ' ' + user.lastName, id: user.id }));
    });

    userService.admins().subscribe(results => {
      this.adminUsers = results.map(user => ({ name: user.firstName + ' ' + user.lastName, id: user.id }));
    });
  }

  ngAfterViewInit(): void {}

  selectionUpdated() {
    this.invalidSelection = !(this.selectedParalegal != null && this.selectedAdmin != null);
  }

  allocateCase() {
    this.isLoading = true;

    this.caseService.allocateCase(this.caseId, this.selectedParalegal.id, this.selectedAdmin.id).subscribe({
      next: () => {
        this.caseService.caseAllocated.next(true);
        this.activeModal.close(true);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}